import { render, staticRenderFns } from "./MissingImage.vue?vue&type=template&id=efe02d76&"
import script from "./MissingImage.vue?vue&type=script&lang=js&"
export * from "./MissingImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/boligvelger-v4/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efe02d76')) {
      api.createRecord('efe02d76', component.options)
    } else {
      api.reload('efe02d76', component.options)
    }
    module.hot.accept("./MissingImage.vue?vue&type=template&id=efe02d76&", function () {
      api.rerender('efe02d76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MissingImage.vue"
export default component.exports